/**
 *
 * PaymentCallback
 *
 */
import { Col, Row } from 'antd';
import { LoadingContainer } from 'app/components/LoadingContainer/Loadable';
import StyledButton from 'app/components/StyledButton';
import News from 'app/pages/Home/components/News';
import { PaymentSuccess } from 'app/pages/NewPaymentCallback/components/Loadable';
import { PaymentFail } from 'app/pages/NewPaymentCallback/components/PaymentFail';
import { getDetailOrderApi, updatePaymentApi } from 'app/services/checkoutApi';
import { getNewApi } from 'app/services/showApi';
import React, { memo, useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { I_Order } from '../Account/ListOrder/slice/types';
import { selectIsLogged, selectTranslations } from '../App/slice/selectors';
import { PaymentCallbackWrapper } from './styled';
import useWindowSize from 'app/hooks/useWindowSize';

interface Props {}

const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5,
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

export const NewPaymentCallback = memo((props: Props) => {
  const location = useLocation();
  const history = useHistory();
  const translations = useSelector(selectTranslations);

  const [loading, setLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState<boolean | null>(true);
  const [detailOrder, setDetailOrder] = useState<I_Order | undefined>(
    undefined,
  );

  // const isLogged = useSelector(selectIsLogged);
  const { device } = useWindowSize();

  // const getDetailOrder = useCallback(async (orderId: string) => {
  //   setLoading(true);
  //   const { data } = await getDetailOrderApi(orderId, true);
  //   setDetailOrder(data);
  //   setLoading(false);
  // }, []);

  const onGoHome = () => history.push('/');

  const getDetailOrder = async (orderId: string, resSuccess: boolean) => {
    setLoading(true);
    try {
      const { data: detailCallbackOrder } = await getDetailOrderApi(
        orderId,
        true,
      );
      if (detailCallbackOrder?.orderState?.value === 'paymentPending') {
        history.push({
          pathname: '/account',
        });
        return;
      }
      setDetailOrder(detailCallbackOrder);
      if (
        detailCallbackOrder?.orderState?.value === 'success' ||
        detailCallbackOrder?.orderState?.value === 'SyncVGS'
      ) {
        setIsSuccess(true);
      } else {
        setIsSuccess(resSuccess);
      }
    } catch (error) {}

    setLoading(false);
  };

  useEffect(() => {
    (async () => {
      const search = new URLSearchParams(location.search);
      const responseOrderId = search.get('vnp_TxnRef');
      const bnPaymentType = search.get('bnPaymentType');
      const vnpResponseCode = search.get('vnp_ResponseCode'); // Only for VNPay
      const isSuccess = (() => {
        if (bnPaymentType === 'Payoo') {
          const resultStatus = search.get('status');
          return resultStatus === '1';
        } else if (bnPaymentType === 'Deposit') {
          const resultStatus = search.get('result_code');
          return resultStatus === '1';
        } else {
          return vnpResponseCode === '00';
        }
      })();
      // Only call vnp_callback for payoo and vnPay
      if (bnPaymentType === 'Payoo' || vnpResponseCode) {
        try {
          setLoading(true);
          await updatePaymentApi(location.search);
        } finally {
          setLoading(false);
        }
      }
      if (responseOrderId) {
        const orderId = vnpResponseCode
          ? responseOrderId.slice(0, responseOrderId.length - 6)
          : responseOrderId;
        getDetailOrder(orderId, isSuccess);
      } else {
        setIsSuccess(isSuccess);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <LoadingContainer isFullPage loading={loading}>
      {detailOrder && (
        <>
          <Row justify="center">
            <Col span={device === 'desktop' ? 12 : 22}>
              {isSuccess !== null && (
                <PaymentCallbackWrapper id="pay" className="main">
                  {isSuccess ? (
                    <PaymentSuccess detailOrder={detailOrder} />
                  ) : (
                    <PaymentFail detailOrder={detailOrder} />
                  )}
                </PaymentCallbackWrapper>
              )}
            </Col>
          </Row>
          <Row style={{ marginTop: 24 }}>
            <Col
              span={24}
              style={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <StyledButton
                textColor="#808080"
                bgColor="white"
                style={{
                  width: 'auto',
                  fontSize: 16,
                  fontWeight: 600,
                  borderRadius: 5,
                }}
                border="1px solid #808080"
                onClick={onGoHome}
              >
                <i className="fa-solid fa-arrow-left"></i>
                <span className="--textBtn" style={{ marginLeft: 8 }}>
                  {' '}
                  {translations ? translations['b2c.txt.back-to-home'] : ''}
                </span>
              </StyledButton>
            </Col>
          </Row>
        </>
      )}
    </LoadingContainer>
  );
});
